<template>
    <router-view></router-view>
</template>

<script>
export default {
    name: "SkupPrijavaBase"
};
</script>

<style scoped>

</style>
